/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type SellingManagementsLandTransportAsPriceManagementListFreightMethod = typeof SellingManagementsLandTransportAsPriceManagementListFreightMethod[keyof typeof SellingManagementsLandTransportAsPriceManagementListFreightMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SellingManagementsLandTransportAsPriceManagementListFreightMethod = {
  AIR: 'AIR',
  OCEAN: 'OCEAN',
} as const;
